import React, { useEffect, useState } from 'react';
import customEventBus from '@common/scripts/libs/eventBus';
import api from '@utils/api';
import ModalDialogWithImage from '@ui/modal/ModalDialogWithImage';
import '@arianee/arn-components'; // Register ARN web components
import ModalDialog from '@common/ui/modal/ModalDialog';
import { useTranslation } from 'react-i18next';
import analytics from '@utils/analytics';
const WalletConnectModal = (props) => {
    var _a, _b, _c, _d;
    // const [clientFactory, setClientFactory] = useState<any>();
    // const [walletAddress, setWalletAddress] = useState('');
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(new URL(window.location.href).searchParams.has('wallet-connected') || false);
    const [modalData, setModalData] = useState();
    const [benefitsList, setBenefitsList] = useState();
    const [CTAsList, setCTAsList] = useState();
    const [arnClientReady, setArnClientReady] = useState(!!window.arnClient);
    const [connectionFailed, setConnectionFailed] = useState(false);
    useEffect(() => {
        customEventBus.on('arnClient:ready', (data) => {
            setArnClientReady(data.ready);
        });
        customEventBus.on('wallet:wallet-connect:failed', ({}) => {
            setConnectionFailed(true);
        });
        api.getPageJson('footer', true).then((data) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const component = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.regions) === null || _a === void 0 ? void 0 : _a.find((el) => el.id === 'walletconnect_modal')) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.find((el) => el.id === props.uuid);
            const benefits = (_e = (_d = component === null || component === void 0 ? void 0 : component.regions) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.components; // benefits_list
            const CTAs = (_g = (_f = component === null || component === void 0 ? void 0 : component.regions) === null || _f === void 0 ? void 0 : _f[1]) === null || _g === void 0 ? void 0 : _g.components; // ctas_list
            if (component)
                setModalData(component);
            if (benefits)
                setBenefitsList(benefits);
            if (CTAs)
                setCTAsList(CTAs);
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        arnClientReady && ((_a = window.arnClient) === null || _a === void 0 ? void 0 : _a.auth.isConnected()) && (React.createElement(ModalDialogWithImage, { image: (_b = modalData === null || modalData === void 0 ? void 0 : modalData.custom) === null || _b === void 0 ? void 0 : _b.image, isOpen: showModal, className: "login-modal no-outline", onRequestClose: () => {
                setShowModal(false);
            } },
            React.createElement("h2", { className: "primary-m mb-8" }, (_c = modalData === null || modalData === void 0 ? void 0 : modalData.data) === null || _c === void 0 ? void 0 : _c.title),
            React.createElement("p", { className: "primary-xs mb-40" }, (_d = modalData === null || modalData === void 0 ? void 0 : modalData.data) === null || _d === void 0 ? void 0 : _d.description), benefitsList === null || benefitsList === void 0 ? void 0 :
            benefitsList.map((el) => (React.createElement("li", { className: "d-block mb-40", key: `benefit-${el.id}` },
                React.createElement("div", { className: "d-flex-align-center" },
                    React.createElement("img", { src: el.custom.icon, alt: "" }),
                    React.createElement("p", { className: "primary-xs text-uppercase bold ml-4" }, el.data.title)),
                React.createElement("p", { className: "primary-x ml-28" }, el.data.description)))), CTAsList === null || CTAsList === void 0 ? void 0 :
            CTAsList.map((el) => (React.createElement("a", { className: "button button--secondary", key: `cta-${el.id}`, href: el.data.link, onClick: () => {
                    analytics.earlyAccess('shop early access', 'fragment');
                } }, el.data.linkText))))),
        connectionFailed && (React.createElement(ModalDialog, { className: "modal--small", isOpen: connectionFailed, contentLabel: t('label.failedwalletconnect.title'), onRequestClose: () => setConnectionFailed(false) },
            React.createElement("p", null, t('label.failedwalletconnect.body'))))));
};
export default WalletConnectModal;
